import { render, staticRenderFns } from "./AdminLTI.vue?vue&type=template&id=5ea4fab5"
import script from "./AdminLTI.vue?vue&type=script&lang=js"
export * from "./AdminLTI.vue?vue&type=script&lang=js"
import style0 from "./AdminLTI.vue?vue&type=style&index=0&id=5ea4fab5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports